//GET_LEAVE_OF_USERS_BY_ID
export const GET_LEAVE_OF_USERS_BY_ID_REQUEST =
  "GET_LEAVE_OF_USERS_BY_ID_REQUEST";
export const GET_LEAVE_OF_USERS_BY_ID_SUCCESS =
  "GET_LEAVE_OF_USERS_BY_ID_SUCCESS";
export const GET_LEAVE_OF_USERS_BY_ID_FAIL = "GET_LEAVE_OF_USERS_BY_ID_FAIL";

//ADD_LEAVE_OF_USERS
export const ADD_LEAVE_OF_USERS_REQUEST = "ADD_LEAVE_OF_USERS_REQUEST";
export const ADD_LEAVE_OF_USERS_SUCCESS = "ADD_LEAVE_OF_USERS_SUCCESS";
export const ADD_LEAVE_OF_USERS_FAIL = "ADD_LEAVE_OF_USERS_FAIL";

//DELETE_LEAVE_OF_USERS
export const DELETE_LEAVE_OF_USERS_REQUEST = "DELETE_LEAVE_OF_USERS_REQUEST";
export const DELETE_LEAVE_OF_USERS_SUCCESS = "DELETE_LEAVE_OF_USERS_SUCCESS";
export const DELETE_LEAVE_OF_USERS_FAIL = "DELETE_LEAVE_OF_USERS_FAIL";

//GET_LEAVE_SETTING
export const GET_LEAVE_SETTING_REQUEST = "GET_LEAVE_SETTING_REQUEST";
export const GET_LEAVE_SETTING_SUCCESS = "GET_LEAVE_SETTING_SUCCESS";
export const GET_LEAVE_SETTING_FAIL = "GET_LEAVE_SETTING_FAIL";

//GET_LEAVE_OF_COMPANY
export const GET_LEAVE_OF_COMPANY_REQUEST = "GET_LEAVE_OF_COMPANY_REQUEST";
export const GET_LEAVE_OF_COMPANY_SUCCESS = "GET_LEAVE_OF_COMPANY_SUCCESS";
export const GET_LEAVE_OF_COMPANY_FAIL = "GET_LEAVE_OF_COMPANY_FAIL";

//ADD_LEAVE_OF_USERS_APPROVE
export const ADD_LEAVE_OF_USERS_APPROVE_REQUEST =
  "ADD_LEAVE_OF_USERS_APPROVE_REQUEST";
export const ADD_LEAVE_OF_USERS_APPROVE_SUCCESS =
  "ADD_LEAVE_OF_USERS_APPROVE_SUCCESS";
export const ADD_LEAVE_OF_USERS_APPROVE_FAIL =
  "ADD_LEAVE_OF_USERS_APPROVE_FAIL";

//ADD_LEAVE_OF_USERS_REJECT
export const ADD_LEAVE_OF_USERS_REJECT_REQUEST =
  "ADD_LEAVE_OF_USERS_REJECT_REQUEST";
export const ADD_LEAVE_OF_USERS_REJECT_SUCCESS =
  "ADD_LEAVE_OF_USERS_REJECT_SUCCESS";
export const ADD_LEAVE_OF_USERS_REJECT_FAIL = "ADD_LEAVE_OF_USERS_REJECT_FAIL";
